export default __webpack_public_path__ + "static/media/blunderbomb.6508f9d4.png";